<span class="productMapper adminRequests vetcorPrice">
   <section class="p-2">
      <div class="stepper-page">
         <div class="splitHeader welcomeHeader">
            <span class="left-h">
               <h4>Off-Cycle Price Change Requests</h4>
            </span>
         </div>

         <div class="averagePriceChanges">
            <ng-container *ngIf="!!dashboardStats">
               <div
                  style="display: inline-block"
                  class="codeStats">
                  <div class="icon-wrapper-wrapper v-bluebg">
                     <div class="icon-wrapper v-bluebg">
                        <i class="icon fas fa-tasks v-whitecolor"></i>
                     </div>
                  </div>
                  <div class="codeStatsWrapper">
                     <h3>Codes Pending Approval</h3>
                     <p class="v-bluecolor">
                        {{ dashboardStats.pending == 0 ? codesRequestedReview : dashboardStats.pending }}
                     </p>
                  </div>
               </div>

               <div
                  style="display: inline-block"
                  class="codeStats">
                  <div class="icon-wrapper-wrapper v-purplebg">
                     <div class="icon-wrapper v-purplebg">
                        <i class="icon fas fa-business-time v-whitecolor"></i>
                     </div>
                  </div>
                  <div class="codeStatsWrapper">
                     <h3>Codes Pending Approval Over 7 Days</h3>
                     <p class="v-purplecolor">
                        {{ dashboardStats.pendingOver7Days }}
                     </p>
                  </div>
               </div>
            </ng-container>
         </div>

         <div class="admin-offcycle-table">
            <vetcor-pricing-table
               (recordUpdated)="onRecordUpdated()"
               [isCaptain]="true"
               [isRequestView]="true"
               [pendingReview]="true"
               [prices]="changeRequests()"></vetcor-pricing-table>
         </div>
      </div>
      <ng-template #loading>
         <vc-spinner></vc-spinner>
      </ng-template>
   </section>
</span>
